import { createTaskBaseXtmQAReportStore } from "./createTaskBaseXtmQAReportStore";
import { Task } from "pages/project/task/task.typing";
import { requestGenerateXtmQAReport } from "api/task.api";

const requestGenerateQAReport = async (task: Task, hubConnectionId: string) => {
  return requestGenerateXtmQAReport(task.id, hubConnectionId);
};

export const useTaskXtmQAStore = createTaskBaseXtmQAReportStore<Task>("task", requestGenerateQAReport);
